import React from 'react';

import ScreenContainer from '@sdk/login/components/layout/ScreenContainer';
import SelectOrg from '@sdk/login/components/SelectOrg';

import { LayoutWithImage } from '../components/LayoutWithImage';
import SlingToastSvg from '../assets/sling-toast.svg';
import gettext from '@sdk/lang/gettext';

type Props = {
  orgs: Array<{
    id: number;
    name: string;
  }>;
  onSelect: (orgId: number) => Promise<void>;
  onCancel: () => void;
  formError?: string;
};
const SelectOrgConnect = ({ orgs, onSelect, onCancel, formError }: Props) => {
  return (
    <LayoutWithImage image={<SlingToastSvg />}>
      <ScreenContainer>
        <SelectOrg
          orgs={orgs}
          onSelect={onSelect}
          onCancel={onCancel}
          subtitle={gettext('Which account would you like to connect to?')}
          requireConfirmation={true}
        />
      </ScreenContainer>
    </LayoutWithImage>
  );
};

export default SelectOrgConnect;
